
import { Component, Vue } from 'vue-property-decorator'
import { mapState } from 'vuex'
import { Toast, Button } from '@finance/sui'
import DotLoader from './components/dot-loader/src/main.vue'

@Component({
  components: {
    'sui-toast': Toast,
    'sui-button': Button,
    DotLoader
  },
  computed: mapState({
    loading: (state: any) => { return state.common.loading },
    payToast: (state: any) => { return state.common.payToast },
    payToastText: (state: any) => { return state.common.payToastText },
    containerClass: (state: any) => { return state.common.containerClass },
    refreshBtnVisiable: (state: any) => { return state.common.refreshBtnVisiable },
  }),
})
export default class App extends Vue {
  refresh = () => {
    window.location.reload()
  }
}
